<template>
    <div class="o-container" :class="{'-has-search-value':showResults, 'loading': loading}">
        <div class="c-search__wrap">

			<div class="o-grid -search-sticky-top">
				<div class="o-grid-9">
					<!-- Title -->
					<div class="c-search-title">{{ t("Que cherchez-vous?") }}</div>
					<!-- Search bar -->
					<div class="c-search-row">
						<div class="c-search-input-text">
							<svg class="o-ico -input-left" role="img">
								<title>input-left</title>
								<use xlink:href="/assets/img/sprite.svg?v=2#search"></use>
							</svg>
							<input v-model="searchInput" type="text" :placeholder="t('Recherche')" class="o-input js-search-input" :aria-label="t('Recherche')">
						</div>
						<div class="c-search-reset" v-if="searchInput!==null">
							<button @click.prevent="resetSearch()" class="c-search-reset__btn js-search-reset__btn" :aria-label="t('Réinitialiser la recherche')">
								<span class="c-search-reset__ico">
									<svg class="o-ico -ico-close" role="img">
										<title>close</title>
										<use xlink:href="/assets/img/sprite.svg?v=2#close"></use>
									</svg>
								</span>
							</button>
						</div>
						<div class="c-search__loading"></div>
					</div>
					<!-- Main filters buttons -->
					<ul v-if="showResults" class="c-search-main-filters">
						<li class="c-search-main-filters__item">
							<button  @click.prevent="selectSection('')" class="c-search-main-filters__link" :class="{'is-active': this.filterSection===null}">Tous les résultats</button>
						</li>
						<li v-for="section in sections" class="c-search-main-filters__item">
							<button @click.prevent="selectSection(section.name)" class="c-search-main-filters__link" :class="{'is-active': this.filterSection==section.name}">{{ section.name }}</button>
						</li>
					</ul>
				</div>
			</div>

			<div class="o-grid -y-sm">
				<div class="o-grid-9 c-search-results__quicklinks">
					<!-- Desktop popular search 3 cols -->
					<div class="o-grid -gutter -popular-search-desktop">
						<div class="o-grid-3" v-if="futur.length">
							<span class="c-search-results__quicklinks__title">{{ t("Futur(e)s étudiant(e)s") }}</span>
							<div class="c-search-results__quicklinks__list">
								<template v-for="(lien, index) in futur">
									<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink c-search-results_quicklink_futur">{{ lien.label }}</a>
									<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink c-search-results_quicklink_futur">{{ lien.label }}</a>
								</template>
							</div>
						</div>
						<div class="o-grid-3" v-if="communaute.length || diplomes.length">
							<template v-if="communaute.length">
								<span class="c-search-results__quicklinks__title">{{ t("Communauté étudiante") }}</span>
								<div class="c-search-results__quicklinks__list" style="margin-bottom: 1rem;">
									<template v-for="(lien, index) in communaute">
										<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink c-search-results_quicklink_etudiant">{{ lien.label }}</a>
										<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink c-search-results_quicklink_etudiant">{{ lien.label }}</a>
									</template>
								</div>
							</template>
							<template v-if="diplomes.length">
								<span class="c-search-results__quicklinks__title">{{ t("Diplomé(e)s") }}</span>
								<div class="c-search-results__quicklinks__list">
									<template v-for="(lien, index) in diplomes">
										<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink c-search-results_quicklink_etudiant">{{ lien.label }}</a>
										<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink c-search-results_quicklink_etudiant">{{ lien.label }}</a>
									</template>
								</div>
							</template>
						</div>
						<div class="o-grid-3" v-if="personnel.length">
							<span class="c-search-results__quicklinks__title">{{ t("Personnel de l'ÉTS") }}</span>
							<div class="c-search-results__quicklinks__list">
								<template v-for="(lien, index) in personnel">
									<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink c-search-results_quicklink_personnel">{{ lien.label }}</a>
									<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink c-search-results_quicklink_personnel">{{ lien.label }}</a>
								</template>
							</div>
						</div>
						<div class="o-grid-3" v-if="entreprises.length">
							<span class="c-search-results__quicklinks__title">{{ t("Entreprises") }}</span>
							<div class="c-search-results__quicklinks__list">
								<template v-for="(lien, index) in entreprises">
									<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink c-search-results_quicklink_entreprises">{{ lien.label }}</a>
									<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink c-search-results_quicklink_entreprises">{{ lien.label }}</a>
								</template>
							</div>
						</div>
					</div>
					<!-- Mobile popular search accordions -->
					<div class="c-accordion -popular-search-mobile">
						<div class="c-accordion__section is-open" data-accordion="wrap" id="section-1">
							<div class="c-accordion__header" data-accordion="trigger">
								<p class="c-accordion__header__title o-title-5">
									<button class="c-accordion__button" aria-expanded="false" type="button" @click="toggleSection(1)">
										<span>
											{{ t("Futur(e)s étudiant(e)s") }}
										</span>
										<span class="c-accordion__icon">
											<svg class="o-ico -ico-arrow-down" role="img">
												<title>arrow-down</title>
												<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
											</svg>
										</span>
									</button>
								</p>
							</div>
							<div class="c-accordion__content" role="region" data-accordion="content">
								<div class="c-accordion__inner">
									<div class="c-accordion__inner__container">
										<div class="c-search-results__quicklinks__list">
											<template v-for="(lien, index) in futur">
												<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink">{{ lien.label }}</a>
												<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink">{{ lien.label }}</a>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="c-accordion__section" data-accordion="wrap" id="section-2">
							<div class="c-accordion__header" data-accordion="trigger">
								<p class="c-accordion__header__title o-title-5">
									<button class="c-accordion__button" aria-expanded="false" type="button" @click="toggleSection(2)">
										<span>
											{{ t("Communauté étudiante") }}
										</span>
										<span class="c-accordion__icon">
											<svg class="o-ico -ico-arrow-down" role="img">
												<title>arrow-down</title>
												<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
											</svg>
										</span>
									</button>
								</p>
							</div>
							<div class="c-accordion__content" role="region" data-accordion="content">
								<div class="c-accordion__inner">
									<div class="c-accordion__inner__container">
										<div class="c-search-results__quicklinks__list">
											<template v-for="(lien, index) in communaute">
												<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink">{{ lien.label }}</a>
												<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink">{{ lien.label }}</a>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="c-accordion__section" data-accordion="wrap" id="section-5">
							<div class="c-accordion__header" data-accordion="trigger">
								<p class="c-accordion__header__title o-title-5">
									<button class="c-accordion__button" aria-expanded="false" type="button" @click="toggleSection(5)">
										<span>
											{{ t("Diplomé(e)s") }}
										</span>
										<span class="c-accordion__icon">
											<svg class="o-ico -ico-arrow-down" role="img">
												<title>arrow-down</title>
												<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
											</svg>
										</span>
									</button>
								</p>
							</div>
							<div class="c-accordion__content" role="region" data-accordion="content">
								<div class="c-accordion__inner">
									<div class="c-accordion__inner__container">
										<div class="c-search-results__quicklinks__list">
											<template v-for="(lien, index) in diplomes">
												<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink">{{ lien.label }}</a>
												<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink">{{ lien.label }}</a>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="c-accordion__section" data-accordion="wrap" id="section-3">
							<div class="c-accordion__header" data-accordion="trigger">
								<p class="c-accordion__header__title o-title-5">
									<button class="c-accordion__button" aria-expanded="false" type="button" @click="toggleSection(3)">
										<span>
											{{ t("Personnel de l'ÉTS") }}
										</span>
										<span class="c-accordion__icon">
											<svg class="o-ico -ico-arrow-down" role="img">
												<title>arrow-down</title>
												<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
											</svg>
										</span>
									</button>
								</p>
							</div>
							<div class="c-accordion__content" role="region" data-accordion="content">
								<div class="c-accordion__inner">
									<div class="c-accordion__inner__container">
										<div class="c-search-results__quicklinks__list">
											<template v-for="(lien, index) in personnel">
												<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink">{{ lien.label }}</a>
												<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink">{{ lien.label }}</a>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="c-accordion__section" data-accordion="wrap" id="section-4">
							<div class="c-accordion__header" data-accordion="trigger">
								<p class="c-accordion__header__title o-title-5">
									<button class="c-accordion__button" aria-expanded="false" type="button" @click="toggleSection(4)">
										<span>
											{{ t("Entreprises") }}
										</span>
										<span class="c-accordion__icon">
											<svg class="o-ico -ico-arrow-down" role="img">
												<title>arrow-down</title>
												<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
											</svg>
										</span>
									</button>
								</p>
							</div>
							<div class="c-accordion__content" role="region" data-accordion="content">
								<div class="c-accordion__inner">
									<div class="c-accordion__inner__container">
										<div class="c-search-results__quicklinks__list">
											<template v-for="(lien, index) in entreprises">
												<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink">{{ lien.label }}</a>
												<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink">{{ lien.label }}</a>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Results count -->
				<div class="o-grid-12 c-search-results__overview">
					<span class="c-search-results__count js-search-results__count">{{ results?results.length:'' }}</span>
					{{ t("Résultats pour") }} :
					<span class="c-search-query__wrap">«&nbsp;<span class="c-search-query">{{ searchInput }}</span>&nbsp;»</span>
				</div>
				<!-- Results -->
				<div class="o-grid-9 c-search-results__scroll js-search-results">
					<div v-for="item in results" class="c-search-results__item">
						<div class="c-search-result__header">
							<span v-if="item.url!='#'" class="c-search-result__title"><a :href="item.url" :target="item.section=='Lien' && item.url.indexOf('https://www.etsmtl.ca')==-1 ? '_blank':'_self'" v-html="item.title"></a></span>
							<span v-else class="c-search-result__title" v-html="item.title"></span>
							<div class="c-search-result__tag"><span class="c-tag">{{ item.section }}</span></div>
						</div>
						<div class="c-search-result__desc">
							<p v-if="item.section=='Bottin' || item.section=='Corps enseignant'" v-html="item.subtitle"></p>
							<p v-if="item.excerpt" v-html="item.excerpt"></p>
						</div>
						<div v-if="item.breadcrumb && item.section != 'Lien' && item.section != 'Link'" class="c-search-result__footer">
							<div class="c-search-breadcrumb">
								<template v-if="item.section!='Bottin'" v-for="(link, lkey) in item.breadcrumb">
									<a v-if="link.url!='#'" :href="link.url" class="c-search-breadcrumb__link">{{ link.title }}</a>
									<span v-else class="c-search-breadcrumb__link">{{ link.title }}</span>
									<span v-if="lkey+1< item.breadcrumb.length" class="c-search-breadcrumb__separator">/</span>

								</template>
								<template v-else>
									<a :href="'mailto:'+item.email" class="c-search-breadcrumb__link">{{ item.email }}</a>
								</template>
								<!-- <span class="c-tag -score" v-if="item.score>0">({{ item.pageviews }} pv) {{ item.score.toFixed(4) }}</span> -->
								<span class="c-tag -score" v-if="item.score>0">{{ item.score.toFixed(4) }}</span>
							</div>
						</div>
					</div>

					<div v-if="searchResults && searchResults.length<totalResults" class="c-search-results__load-more js-search-results__load-more">
						<button @click.prevent="search(from = searchResults.length)" class="c-search-results__load-more__btn" :disabled="loading">
							<div class="c-search__loading" v-if="loading"></div>

							<svg class="o-ico -ico-arrow-down" role="img" v-else>
								<title>arrow-down</title>
								<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
							</svg>
							<span class="c-search-results__load-more__text">{{ t("Charger plus de résultats") }}</span>
						</button>
					</div>
				</div>
				<!-- Sub filters : Apparaît et se met à jour seulement si un main filter est sélectionné -->
				<div v-if="showResults" class="o-grid-3 -col-sticky-top c-search-sub-filters">
					<div v-if="sectionCategories.length>0" class="u-hide-under-sm">
						<div class="o-title-5">{{ filterSection }}</div>
						<hr>
						<div class="o-form c-search-sub-filters__list">
							<div v-for="(cat, index) in sectionCategories" class="o-checkbox__wrap">
								<input :id="'cat-'+index" v-model="selectedCategories" :value="cat" class="o-checkbox" type="checkbox">
								<label class="o-checkbox-label" :for="'cat-'+index">
									{{ cat }}
								</label>
							</div>
						</div>
					</div>
					<div v-if="sectionCategories.length>0" class="u-hide-over-sm">
						<div class="c-accordion">
							<div class="c-accordion__section is-open" data-accordion="wrap">
								<div class="c-accordion__header" data-accordion="trigger">
									<h3 class="c-accordion__header__title o-title-5">
										<button class="c-accordion__button" aria-expanded="false" type="button" @click="toggleMobileFilters($event.currentTarget)">
											<span>
												{{ filterSection }}
											</span>
											<span class="c-accordion__icon">
												<svg class="o-ico -ico-arrow-down" role="img">
													<title>arrow-down</title>
													<use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
												</svg>
											</span>
										</button>
									</h3>
								</div>
								<div class="c-accordion__content" role="region" data-accordion="content">
									<div class="c-accordion__inner">
										<div class="c-accordion__inner__container">
											<div class="o-form c-search-sub-filters__list">
												<div v-for="(cat, index) in sectionCategories" class="o-checkbox__wrap">
													<input :id="'cat2-'+index" v-model="selectedCategories" :value="cat" class="o-checkbox" type="checkbox">
													<label class="o-checkbox-label" :for="'cat2-'+index">
														{{ cat }}
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Quand Tous les resultats est selectionner -->
					<!--div v-else class="c-search-default-filters u-hide-under-sm">
						<div class="" v-if="futur.length">
							<span class="c-search-results__quicklinks__title">{{ t("Futur(e)s étudiant(e)s") }}</span>
							<div class="c-search-results__quicklinks__list">
								<template v-for="(lien, index) in futur">
									<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink">{{ lien.label }}</a>
									<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink">{{ lien.label }}</a>
								</template>
							</div>
						</div>
						<div class="" v-if="communaute.length">
							<span class="c-search-results__quicklinks__title">{{ t("Communauté étudiante") }}</span>
							<div class="c-search-results__quicklinks__list">
								<template v-for="(lien, index) in communaute">
									<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink">{{ lien.label }}</a>
									<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink">{{ lien.label }}</a>
								</template>
							</div>
						</div>
						<div class="" v-if="personnel.length">
							<span class="c-search-results__quicklinks__title">{{ t("Personnel de l'ÉTS") }}</span>
							<div class="c-search-results__quicklinks__list">
								<template v-for="(lien, index) in personnel">
									<a v-if="lien.lienUrl" :href="lien.lienUrl" class="c-search-results__quicklink">{{ lien.label }}</a>
									<a v-else href="#" @click.prevent="searchInput=lien.motsRecherche" class="c-search-results__quicklink">{{ lien.label }}</a>
								</template>
							</div>
						</div>
					</div-->
				</div>
			</div>
        </div>
    </div>
</template>

<script>
import debounce from 'debounce';

export default {
	name: 'Search',
	data() {
		return {
			loading: false,
			searchInput: null,
			searchResults: null,
			categories: [],
			selectedCategories: [],
			typingTimer: null,
			filterSection: null,
			futur: [],
			communaute: [],
			diplomes: [],
			personnel: [],
			entreprises: [],
			siteId: 1,
			showResults: false,
			filtersActive : false,
			languageUrl: '/',
			totalResults: 0,
			debounceDelay: 500,
			debounceSearch: null,
			sections: [],
		}
	},
	created() {
		let lang = document.documentElement.lang;
		if (lang === 'fr-CA') {
			this.siteId = 1;
		} else {
			this.siteId = 2;
			this.languageUrl = '/en/';
		}
		this.getMost();

	},
	watch: {
		searchInput: function (searchInput) {

			// if (searchInput != '') {
			// 	this.suggest();
			// }

			if (searchInput && searchInput.length >= 3) {
				this.search();
			} else {
				this.searchResults = null;
				this.allSearchResults = null;
				this.filterSection = null;
				if (this.searchInput === '') {
					this.resetSearch();
				}
			}
		}
	},
	computed: {
		results() {
			let results = [];

			if (this.searchResults) {
				if (this.filterSection!==null) {
					results = this.searchResults.filter(item => item.section === this.filterSection);
				} else {
					results = this.searchResults;
				}
			}

			if (this.selectedCategories.length>0) {
				results = results.filter(item => {
					let hasCategory = false;
					this.selectedCategories.forEach((cat) => {
						if (item.categories.indexOf(cat) > -1) {
							hasCategory = true;
						}
					});
					return hasCategory;
				});
			}

			return results;
		},
		sectionCategories() {
			let categories = [];

			if (this.filterSection && this.categories[this.filterSection] !== undefined) {
				Object.keys(this.categories[this.filterSection]).forEach((key) => {
					categories.push(this.categories[this.filterSection][key]);
				});
			}

			return categories;
		}
	},
	methods: {
		t(string) {
			return SearchLocalisation[string];
		},
		getMost() {
			fetch(this.languageUrl + 'api/search/most?siteId=' + this.siteId, {
				method: 'GET',
				headers: {
					'Accept': 'application/json'
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.futur) this.futur = data.futur;
					if (data.communaute) this.communaute = data.communaute;
					if (data.diplomes) this.diplomes = data.diplomes;
					if (data.personnel) this.personnel = data.personnel;
					if (data.entreprises) this.entreprises = data.entreprises;
				})
		},
		search: function (from = 0, perPage = 25) {
			this.loading = true;
			let debounceDelay = (from == 0) ? 500 : 0;


			if (this.debounceSearch) {
				clearTimeout(this.debounceSearch);
			}
			this.debounceSearch = setTimeout(() => {
				let searchInput = this.searchInput;
				fetch(this.languageUrl + 'api/search?s=' + searchInput + '&siteId=' + this.siteId + '&from=' + from + "&perPage=" + perPage, {
					method: 'GET',
					headers: {
						'Accept': 'application/json'
					}
				})
					.then(response => response.json())
					.then(data => {
						if (this.searchInput) {
							if (from > 0) {
								this.searchResults = [...this.searchResults, ...data.results];
								this.allSearchResults = [...this.allSearchResults, ...data.results];
								Object.keys(data.categories).forEach((key) => {
									if (this.categories[key] === undefined) {
										this.categories[key] = {};
									}
									this.categories[key] = Object.assign({}, this.categories[key], data.categories[key]);
								});
							} else {
								this.searchResults = this.allSearchResults = data.results;
								this.categories = data.categories
							}
							this.totalResults = data.totalResults;

							window.dataLayer = window.dataLayer || [];
							window.dataLayer.push({
								'event': 'search',
								'search_query': this.searchInput,
								'results': data.length
							});

							setTimeout(() => {
								this.showResults = true;
							}, 15);
						}
						if (from == 0) {
							this.selectedCategories = [];
							this.filterSection = null;

							if (data.totalResults > this.searchResults.length) { // get at least 200 results to populate sections and categories filters
								this.$nextTick(() => {
									this.search(this.searchResults.length, (200-perPage))
								});
							}
						}

					})
					.finally(() => {
						this.loading = false;
						this.getSections();
					});
			}, debounceDelay);
		},
		resetSearch() {
			this.showResults = false;
			this.searchInput = null;
			this.searchResults = null;
			this.filterSection = null;
			this.loading = false;
		},
		toggleSection(index) {
			document.querySelectorAll('.c-accordion__section').forEach((section) => {
				if (section.id !== 'section-' + index) {
					section.classList.remove("is-open");
				}
			});
			document.querySelector('#section-' + index).classList.toggle("is-open");
		},
		toggleMobileFilters(element) {
			element.parentElement.parentElement.parentElement.classList.toggle("is-open");
		},
		selectSection(section) {
			if (section.length > 0) {
				this.filterSection = section;
			} else {
				this.filterSection = null;
			}
			this.selectedCategories = [];
		},

		getSections() {
			let sections = [];


			if (this.allSearchResults) {
				this.allSearchResults.forEach(item => {
					let section = {
						name: item.section,
						count: 1
					}
					if (sections.length > 0) {
						let sectionIndex = sections.findIndex(s => s.name === item.section);
						if (sectionIndex > -1) {
							sections[sectionIndex].count++;
						} else {
							sections.push(section);
						}
					} else {
						sections.push(section);
					}
				});
			}

			let order = [
				'Programmes',
				'Course',
				'Cours',
				'Pages',
				'Projets de recherche pour étudiants',
				'Research Projects for Students',
				'Actualités',
				'News',
				'Événements',
				'Events',
				'Documents'
			];

			sections.sort((a, b) => {
				if (order.indexOf(a.name) > -1 && order.indexOf(b.name) > -1) {
					return order.indexOf(a.name) - order.indexOf(b.name);
				}
				return 1;
			});

			/*sections.sort((a, b) => {
				if (a.name === 'Sites' || a.name === 'Cours' || a.name === 'Pages' || a.name === 'Projets de recherche pour étudiants' || a.name === 'Programmes') {
					return -1;
				}
				if (b.name === 'Sites' || b.name === 'Cours' || b.name === 'Pages' || b.name === 'Projets de recherche pour étudiants' || b.name === 'Programmes') {
					return 1;
				}
				return a.name>=b.name ? 1 : -1;
			});*/

			this.sections = sections;
		},


		// suggest: debounce(function () {
		// 	console.log('icici2')

		// 	if (this.searchInput && this.searchInput.length >= 3) {
		// 		fetch(this.languageUrl + 'api/search/suggest?s=' + this.searchInput + '&siteId=' + this.siteId, {
		// 			method: 'GET',
		// 			headers: {
		// 				'Accept': 'application/json'
		// 			}
		// 		})
		// 			.then(response => response.json())
		// 			.then(data => {
		// 				console.log(data)
		// 			})
		// 	}
		// }, 200)
	}
}
</script>